import { DynamicComponentLoaderModule } from '@adaptiva/core/loaders';
import { ContainerComponentModule } from '@adaptiva/widgets/container';
import { InputComponentModule } from '@adaptiva/widgets/input';
import { SignpostComponentModule } from '@adaptiva/widgets/signpost';
import { TextComponentModule } from '@adaptiva/widgets/text';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RecurringByDateComponent } from './recurring-by-date.component';

@NgModule({
	imports: [
		CommonModule,
		ContainerComponentModule,
		DynamicComponentLoaderModule.forChild(RecurringByDateComponent),
		InputComponentModule,
		SignpostComponentModule,
		TextComponentModule,
	],
	declarations: [
		RecurringByDateComponent
	],
	exports: [
		RecurringByDateComponent
	]
})
export class RecurringByDateModule { }
